import {css, getSimilarColor} from '../utils.js';

const themedStyles = css`
    /* Icon Button and Variants CSS */

    /* Icon Button Base */

    .ddk-container .ddk-icon-button {
        display: flex;
        height: var(--ddk-grid-5, 40px);
        width: 100%;
        min-width: var(--ddk-grid-5, 40px);
        padding: 0px;
        justify-content: center;
        align-items: center;
        gap: var(--ddk-grid-1, 8px);
        font-size: var(--ddk-font-size-sm);
        cursor: pointer;
        transition: background-color 0.3s;
    }

    .ddk-container .ddk-icon-button:has(> :nth-child(2)) {
        padding: var(--ddk-padding-none) var(--ddk-padding-medium);
    }

    .ddk-container .ddk-icon-button > :is(i, i::before, svg) {
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        justify-content: center;
        font-size: var(--ddk-font-size-md);
        height: 24px;
        width: 24px;
    }

    .ddk-container .ddk-icon-button p {
        font-family: ${props => props.theme.font_family};
        font-size: var(--ddk-font-size-sm);
        font-style: normal;
        font-weight: var(--ddk-font-normal);
        line-height: 20px;
        letter-spacing: 0.175px;
        text-transform: uppercase;
    }

    /* Icon Button Primary */

    .ddk-container .ddk-icon-button.primary {
        background-color: ${props => props.theme.accent};
        border: none;
    }

    .ddk-container .ddk-icon-button.primary > * {
        color: ${props =>
            props.theme.button_text !== props.theme.accent
                ? props.theme.button_text
                : 'var(--ddk-icon-interactive-inverse-primary)'};
    }

    .ddk-container .ddk-icon-button.primary:hover {
        background-color: ${props =>
            getSimilarColor(props.theme.accent, 'darken', 15)};
    }

    .ddk-container .ddk-icon-button.primary:focus {
        background-color: ${props =>
            getSimilarColor(props.theme.accent, 'darken', 15)};
    }

    /* Icon Button Secondary */

    .ddk-container .ddk-icon-button.secondary {
        border: 2px solid ${props => props.theme.accent};
        background: var(--ddk-surface-surface-primary, #fff);
    }

    .ddk-container .ddk-icon-button.secondary > * {
        color: ${props => props.theme.accent};
    }

    .ddk-container .ddk-icon-button.secondary:hover,
    .ddk-icon-button.secondary:focus {
        background-color: ${props => props.theme.accent};
    }

    .ddk-container .ddk-icon-button.secondary:hover *,
    .ddk-icon-button.secondary:focus * {
        color: ${props =>
            props.theme.button_text !== props.theme.accent
                ? props.theme.button_text
                : 'var(--ddk-icon-interactive-inverse-primary)'};
    }

    /* Icon Button Ghost */

    .ddk-container .ddk-icon-button.ghost {
        border: none;
        background: none;
    }

    .ddk-container .ddk-icon-button.ghost > * {
        color: ${props => props.theme.accent};
    }

    .ddk-container .ddk-icon-button.ghost:hover,
    .ddk-icon-button.ghost:focus {
        background-color: ${props => props.theme.accent};
    }

    .ddk-container .ddk-icon-button.ghost:hover *,
    .ddk-icon-button.ghost:focus * {
        color: ${props =>
            props.theme.button_text !== props.theme.accent
                ? props.theme.button_text
                : 'var(--ddk-icon-interactive-inverse-primary)'};
    }

    /* Tooltip CSS and Tippy Theming */

    /* TODO: Add Styling Variables and Props for Menus */

    .tippy-box[data-theme~='label-tooltip'] {
        display: inline-flex;
        padding: var(--ddk-padding-xs, 8px) var(--ddk-padding-sm, 16px);
        justify-content: center;
        align-items: center;
        text-align: center;
        color: ${props =>
            props.theme.tooltip_text ?? 'var(--ddk-text-base-inverse-primary)'};
        font-family: ${props => props.theme.font_family};
        font-size: ${props =>
            props.theme.tooltip_font_size ?? 'var(--ddk-font-size-sm)'};
        font-style: var(--ddk-font-normal));
        font-weight: var(--ddk-font-semi-light);
        line-height: 20px; /* 142.857% */
        letter-spacing: 0.035px;
        border-radius: var(--ddk-radius-none, 0px);
        border: 1px solid var(--ddk-border-accent-secondary, #8ea8cc);
        background: ${props =>
            props.theme.tooltip_background_color ??
            'var(--ddk-surface-accent-surface2)'};
        box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.1),
            0px 3px 3px 0px rgba(0, 0, 0, 0.09),
            0px 8px 5px 0px rgba(0, 0, 0, 0.05),
            0px 14px 6px 0px rgba(0, 0, 0, 0.01),
            0px 21px 6px 0px rgba(0, 0, 0, 0);
    }

    .tippy-box[data-theme~='label-tooltip'][data-placement^='top'] > .tippy-arrow::before {
        color: ${props =>
            props.theme.tooltip_background_color ??
            'var(--ddk-surface-accent-surface2)'};
      }

    .tippy-box[data-theme~='menu-popover'] {
        border: 1px solid ${props => props.theme.accent};
        border-radius: var(--ddk-radius-xs);
        background: var(--ddk-surface-base-surface-1, #fff);
        box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.1),
            0px 10px 10px 0px rgba(0, 0, 0, 0.09),
            0px 23px 14px 0px rgba(0, 0, 0, 0.05),
            0px 41px 16px 0px rgba(0, 0, 0, 0.01),
            0px 64px 18px 0px rgba(0, 0, 0, 0);
    }
`;
export default themedStyles;
